import AppMenu from './AppMenu';
import AppTopBar from './AppTopBar';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import ErrorComponent from '@components/error';
import React from 'react';
import cn from 'classnames';
import { configDataSelector } from 'ducks/config/selectors';
import styles from './index.module.scss';
import { useSelector } from 'react-redux';
import { GlobalModals } from '@clean-code/components/GlobalModals/GlobalModals';
import { AlertsDrawerProvider } from '_clean-code/contexts/AlertsDrawerContext';
import { AlertsSidePanel } from '_clean-code/components/AlertsSidePanel';
import { useFeatureFlags } from '@hooks/useFeatureFlags';

interface AppLayoutProps extends React.HTMLAttributes<HTMLDivElement> {
  mainContentClassName?: string;
  headerTitleClassName?: string;
  headerTitleTextClassName?: string;
}

function AppLayout(props: AppLayoutProps) {
  const userConfig = useSelector(configDataSelector);
  const { alertsV2 } = useFeatureFlags();

  function fallbackRender({ error }: FallbackProps) {
    if (
      error.message?.includes('Failed to fetch dynamically imported module')
    ) {
      window.location.href = '/';
    }
    return <ErrorComponent error={error} resetErrorBoundary={() => {}} />;
  }

  const content = (
    <div className={cn(styles.root, props.className)}>
      <div className={styles.header}>
        <AppTopBar
          title={props.title}
          titleClassName={props.headerTitleClassName}
          titleTextClassName={props.headerTitleTextClassName}
        />
      </div>
      <div
        className={cn(
          styles.menuBarCell,
          userConfig.isSidebarCollapsed && styles.sidebarCollapsed
        )}
      >
        <AppMenu />
      </div>
      <div className={cn(styles.mainContentCell, props.mainContentClassName)}>
        <ErrorBoundary fallbackRender={fallbackRender}>
          {props.children}
        </ErrorBoundary>
      </div>
      <GlobalModals />
    </div>
  );

  if (!alertsV2) return content;

  return (
    <AlertsDrawerProvider>
      {content}
      {/* AlertsSidePanel renders into document.body via a portal */}
      <AlertsSidePanel />
    </AlertsDrawerProvider>
  );
}

export default AppLayout;
